'use client';

import { Button } from '@common/components';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { PageNavigation } from '@/components/client';
import { ROUTES } from '@/constants';

interface FestivalListErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const FestivalListErrorPage = ({
  error,
  reset,
}: FestivalListErrorPageProps) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <PageNavigation title="동네축제" />
      <section className="mx-auto flex min-h-[50vh] w-full max-w-screen-sm flex-col items-center justify-center gap-16 px-20 py-40 text-center">
        <h1 className="m-0 font-700 text-Gray-900 typo-h6">
          축제 목록을 불러오지 못했어요
        </h1>
        <p className="m-0 text-Gray-600 typo-body4">
          잠시 후 다시 시도해 주세요.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-8">
          <Button dimensions="H40" onClick={reset}>
            다시 시도
          </Button>
          <Button asChild theme="sub-line" dimensions="H40">
            <CustomLink href={ROUTES.HOME.pathname}>홈으로</CustomLink>
          </Button>
        </div>
      </section>
    </>
  );
};

export default FestivalListErrorPage;
